<template>
  <div id="work">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Work",
  watch: {
    $route(newValue) {
      this.$store.dispatch("setActiveName", "index");
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#work {
  width: 100%;
  height: 100%;
  overflow: auto;
}
</style>
